/**
 * @return {{feature: string}}
 */
export const share = () => ({
  feature: 'partager',
});
